import { createDraftSafeSelector, createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selfChainSelector = (state: RootState) => state.chain;

export const chainSelector = createDraftSafeSelector(
  selfChainSelector,
  (state) => {
    return state.chainId;
  }
);
